import { IAppState } from '../../common/state';
import { IEmptyState } from '../../types/emptyState';

/**
 * Блок пустой выдачи. Ручка поиска присылает его только участникам эксперимента и только когда
 * объявлений нет: в контрольной группе поля нет, и выдача выглядит как раньше.
 */
export function selectEmptyState(state: IAppState): IEmptyState | null {
  return state.results.emptyState;
}
